import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { createAsyncAction } from "./utils";
import { GET_CATEGORIES_QUERY } from "../lib/queries/categories";
export var getCategories = createAsyncAction('getCategories', function () {
  return {
    makeRequest: function () {
      var _makeRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(state, _ref) {
        var _financialCategoriesD;

        var apolloClient, financialCategoriesData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apolloClient = _ref.apolloClient;
                _context.next = 3;
                return apolloClient.query({
                  query: GET_CATEGORIES_QUERY
                });

              case 3:
                financialCategoriesData = _context.sent;
                return _context.abrupt("return", (_financialCategoriesD = financialCategoriesData.data.financialTransactionCategories) === null || _financialCategoriesD === void 0 ? void 0 : _financialCategoriesD.categories);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function makeRequest(_x, _x2) {
        return _makeRequest.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL2NhdGVnb3JpZXMuanMiXSwibmFtZXMiOlsiY3JlYXRlQXN5bmNBY3Rpb24iLCJHRVRfQ0FURUdPUklFU19RVUVSWSIsImdldENhdGVnb3JpZXMiLCJtYWtlUmVxdWVzdCIsInN0YXRlIiwiYXBvbGxvQ2xpZW50IiwicXVlcnkiLCJmaW5hbmNpYWxDYXRlZ29yaWVzRGF0YSIsImRhdGEiLCJmaW5hbmNpYWxUcmFuc2FjdGlvbkNhdGVnb3JpZXMiLCJjYXRlZ29yaWVzIl0sIm1hcHBpbmdzIjoiOztBQUFBLFNBQVNBLGlCQUFUO0FBQ0EsU0FBU0Msb0JBQVQ7QUFFQSxPQUFPLElBQU1DLGFBQWEsR0FBR0YsaUJBQWlCLENBQUMsZUFBRCxFQUFrQjtBQUFBLFNBQU87QUFDckVHLElBQUFBLFdBQVc7QUFBQSxpRkFBRSxpQkFBT0MsS0FBUDtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBZ0JDLGdCQUFBQSxZQUFoQixRQUFnQkEsWUFBaEI7QUFBQTtBQUFBLHVCQUMyQkEsWUFBWSxDQUFDQyxLQUFiLENBQW1CO0FBQ3ZEQSxrQkFBQUEsS0FBSyxFQUFFTDtBQURnRCxpQkFBbkIsQ0FEM0I7O0FBQUE7QUFDTE0sZ0JBQUFBLHVCQURLO0FBQUEsMEVBSUpBLHVCQUF1QixDQUFDQyxJQUF4QixDQUE2QkMsOEJBSnpCLDBEQUlKLHNCQUE2REMsVUFKekQ7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsT0FBRjs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUQwRCxHQUFQO0FBQUEsQ0FBbEIsQ0FBdkMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjcmVhdGVBc3luY0FjdGlvbiB9IGZyb20gJy4vdXRpbHMnO1xuaW1wb3J0IHsgR0VUX0NBVEVHT1JJRVNfUVVFUlkgfSBmcm9tICcuLi9saWIvcXVlcmllcy9jYXRlZ29yaWVzJztcblxuZXhwb3J0IGNvbnN0IGdldENhdGVnb3JpZXMgPSBjcmVhdGVBc3luY0FjdGlvbignZ2V0Q2F0ZWdvcmllcycsICgpID0+ICh7XG4gIG1ha2VSZXF1ZXN0OiBhc3luYyAoc3RhdGUsIHsgYXBvbGxvQ2xpZW50IH0pID0+IHtcbiAgICBjb25zdCBmaW5hbmNpYWxDYXRlZ29yaWVzRGF0YSA9IGF3YWl0IGFwb2xsb0NsaWVudC5xdWVyeSh7XG4gICAgICBxdWVyeTogR0VUX0NBVEVHT1JJRVNfUVVFUlksXG4gICAgfSk7XG4gICAgcmV0dXJuIGZpbmFuY2lhbENhdGVnb3JpZXNEYXRhLmRhdGEuZmluYW5jaWFsVHJhbnNhY3Rpb25DYXRlZ29yaWVzPy5jYXRlZ29yaWVzO1xuICB9LFxufSkpO1xuIl19